module.exports = __webpack_public_path__ + "img/audio-3.68c69796.jpg";